import React from "react";
import { SectionHeading } from "./SectionHeading";
type DataTableProps = {
  id: string;
  eyebrow: string;
  title: string;
  intro?: string;
  columns: string[];
  rows: string[][];
  note?: string;
  highlightColumn?: number;
  background?: "white" | "soft";
};
export function DataTable({
  id,
  eyebrow,
  title,
  intro,
  columns,
  rows,
  note,
  highlightColumn,
  background = "white"
}: DataTableProps) {
  return <section className={`${background === "soft" ? "bg-soft" : "bg-white"} py-8 lg:py-14`} aria-labelledby={id} data-id="element-166" data-mp="yv61h2xklyjt">
      <div className="mx-auto max-w-[1320px] px-5 lg:px-10" data-id="element-167" data-mp="13wvg0sk04ucn">
        <SectionHeading id={id} eyebrow={eyebrow} title={title} intro={intro} data-id="element-168" data-mp="oyjikjot1hkf" />
        <div className="mt-10 overflow-x-auto rounded-lg border border-line bg-white" data-id="element-169" data-mp="tx4lwrzcshd3">
          <table className="w-full min-w-[720px] border-collapse text-left text-sm" data-id="element-170" data-mp="tyxsk79yv1l3">
            <thead data-id="element-171" data-mp="2j9y9v4xgrp2a">
              <tr data-id="element-172" data-mp="2ob5h92vp2m8f">
                {columns.map((column, index) => <th key={`column-${index}`} scope="col" className={`px-5 py-4 font-bold text-white ${index === highlightColumn ? "bg-rinnai" : "bg-ink"}`} data-id="element-173" data-mp="2oaciop6w331d" data-mpi={index}>
                    {column || <span className="sr-only" data-id="element-174" data-mp="veccsgekh1ay">Detail</span>}
                  </th>)}
              </tr>
            </thead>
            <tbody data-id="element-175" data-mp="1a6cq7e5trg3t">
              {rows.map(row => <tr key={row[0]} className="border-t border-line even:bg-soft" data-id="element-176" data-mp="15688xlx3ehcj">
                  {row.map((cell, index) => index === 0 ? <th key={`${row[0]}-label`} scope="row" className="px-5 py-4 font-bold text-ink" data-id="element-177" data-mp="cghwdhb3znij">{cell}</th> : <td key={`${row[0]}-${index}`} className={`px-5 py-4 leading-6 ${index === highlightColumn ? "bg-redTint font-semibold text-ink" : "text-muted"}`} data-id="element-178" data-mp="qh2cg5pn358c">{cell}</td>)}
                </tr>)}
            </tbody>
          </table>
        </div>
        {note && <p className="mt-5 text-xs leading-5 text-muted" data-id="element-179" data-mp="1xtb3y42k89y1">{note}</p>}
      </div>
    </section>;
}